// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-6a02b072]{outline:1px solid #ccc;padding:5px;margin:5px;background-color:#282828;color:#fff}.string[data-v-6a02b072]{color:green!important}.number[data-v-6a02b072]{color:#ff8c00!important}.boolean[data-v-6a02b072]{color:#00f!important}.null[data-v-6a02b072]{color:#f0f!important}.key[data-v-6a02b072]{color:red!important}", ""]);
// Exports
module.exports = exports;
